import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=07c5a6fc&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=ts"
export * from "./MenuItem.vue?vue&type=script&lang=ts"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=07c5a6fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c5a6fc",
  null
  
)

export default component.exports